import { createHashMap } from '../create-hashmap';

/**
 * Checks if two objects match by comparing their key-value pairs (includes nesting).
 * If field order is not important to the operation, check-stringify-match.ts should be used
 *
 * @template T - The type of the first object.
 * @template U - The type of the second object.
 * @param {T} obj1 - The first object to compare.
 * @param {U} obj2 - The second object to compare.
 * @returns {boolean} - Returns `true` if the objects match, otherwise `false`.
 */
export function checkHashMapMatch<T, U>(obj1: T, obj2: U): boolean {
	const map1 = createHashMap(obj1);
	const map2 = createHashMap(obj2);

	if (map1.size !== map2.size) {
		return false;
	}

	for (const [key, value] of map1) {
		if (!map2.has(key) || map2.get(key) !== value) {
			return false;
		}
	}

	return true;
}
